/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    $(document).ready(function () {
        $(".liquid").imgLiquid();

        setTimeout(function(){
            $('body, html').scrollTop(0);
            $('.load-overlay').velocity('fadeOut');
        }, 100);

        // MatchHeigt
        $('.thumbnail_content p').matchHeight();
        $('.card .card-header').matchHeight();
        $('.packages--blocks .card .price').matchHeight();
        $('.packages--blocks .card-content .card-usps').matchHeight();
        $('.content .col-md-6').matchHeight();

        // Nav trigger
        $('.navTrigger').click(function(){
            $(this).toggleClass('active');
            $('.primary-nav').slideToggle( "slow", function() {
                $(this).toggleClass('open');
            });
        });

        // Smooth scroll to anchor
        $('a[href^="#"]').on('click',function (e) {
            e.preventDefault();

            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({'scrollTop': $target.offset().top}, 900, 'swing', function () {
                window.location.hash = target;
            });
        });

        // Slick sliders
        $('.usp--slider').slick({
            dots: false,
            arrows: false,
            infinite : true,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.reviews--slider').slick({
            dots: true,
            arrows: true,
            centerMode: true,
            centerPadding: '25px',
            infinite : true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            prevArrow: '<span class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        centerPadding: '0px',
                    }
                }
            ]
        });

        $('.work--slider').slick({
            dots: false,
            arrows: false,
            infinite : true,
            autoplay: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $(".coverage-form").validate();
        $('.request').validate();

        if ($('#map').length > 0) {
            mapboxgl.accessToken = 'pk.eyJ1IjoiamFja2RldnJldWdkIiwiYSI6ImNqMmE4dnpueTAwMGkycW8wZ3E3OTJ4Zm0ifQ.byJAt9gpTuaZIzc9c6Fi1w';

            var map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/streets-v10',
                center: [5.526120100000071, 52.45429189999999],
                zoom: 10,
                bearing: 0,
                pitch: 0,
                boxZoom: false,
                interactive: false,
                doubleClickZoom: false
            });

            var ajax_url =  $('#map').attr('data-url');

            $.getJSON( ajax_url + "/ajax/pointers.php", function(data) {
                var geojson = data;

                // add markers to map
                geojson.features.forEach(function(marker) {
                    // create a DOM element for the marker
                    var el = document.createElement('div');
                    el.className = 'marker';

                    // add marker to map
                    new mapboxgl.Marker(el, {offset: [-50 / 2, -50 / 2]}).setLngLat(marker.geometry.coordinates).addTo(map);
                });
            }); 
        }

        $(window).scroll(function(){
            checkDivs();
        }); 

        $.fn.isOnScreen = function(){
              
          var win = $(window);
              
          var viewport = {
            top : win.scrollTop(),
            left : win.scrollLeft()
          };
          
          viewport.right = viewport.left + win.width();
          viewport.bottom = viewport.top + win.height();
              
          var bounds = this.offset();
              bounds.right = bounds.left + this.outerWidth();
              bounds.bottom = bounds.top + this.outerHeight();
              
          return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
              
        };

        var checkDivs = function(){
          $('.anim.start').each(function(){
            if($(this).isOnScreen() === true) {
              var anim = $(this).attr('data-anim');
              var speed = $(this).attr('data-speed');
              var delay = $(this).attr('data-delay');
              
              if(speed === null){
                speed = 500;
              }

              if(anim === 'fadeUp'){
                $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeDown'){
                $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeLeft'){
                $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeRight'){
                $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeRotate'){
                $(this).velocity({translateZ: 0, rotateZ: "-=0", opacity: 1}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this)
                    .velocity({translateZ: 0, rotateZ: "-=60"}, {duration: speed, delay: delay}).velocity("reverse");
              }

            }
          });
        };

        $(window).resize(function(){
          checkDivs();
        });

        $('.anim').each(function(){
          $(this).addClass('start').css('opacity', 0);
        });

        checkDivs();

        var flag = false;
        
        $('button[type="submit"].btn').click(function(){
            var valid = $(".request").valid();

            if(!flag && valid == true) {
                flag = true;
               
                $('button[type="submit"].btn').hide();
                $('.lds-ellipsis').show();
            }
        });

    });
})(jQuery); // Fully reference jQuery after this point.